// src/hooks/useNotificationCable.ts
import { useEffect } from "react";
import { cable } from "@/utils/cable";

// This hook subscribes to the NotificationsChannel for the current user
export function useNotificationCable({ userId, onNotification }: { userId: string, onNotification: (data: any) => void }) {
  useEffect(() => {
    if (!userId) return;
    const subscription = cable.subscriptions.create(
      { channel: "NotificationsChannel", id: userId },
      {
        received: (data: any) => {
          onNotification(data);
        },
      }
    );
    return () => {
      cable.subscriptions.remove(subscription);
    };
  }, [userId, onNotification]);
}
